import React, { useState } from 'react';

const FormSubmitAlertMsg = ({isSubmitted, errorMsg}) =>{
  if(isSubmitted){
    return(
      <h4 className="bg-white p-20 text-center">
        Thank you! Record submitted successfully.
      </h4>
    )
  }else if(errorMsg){
    return(
      <div className="bg-red-white text-dark-red p-15 text-center brd-5 m-b-15">
        {errorMsg}
      </div>
    )
  }

  return null;
}

export default FormSubmitAlertMsg;